// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import { FormFieldStyle } from "@guestsupply/MobiusOverrides/FormField/FormField";
import { quickOrderProductListStyles } from "@guestsupply/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { mergeWithCss } from "@guestsupply/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css`
        padding-bottom: 0;
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...mergeWithCss(cartLineSharedStyles.productDescription, {
        productDetailLink: {
            css: css`
                min-height: initial;
            `,
        },
    }),
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...mergeWithCss(cartLineSharedStyles.productAvailability, {
        messageText: {
            typographyProps: {
                css: css`
                    max-width: unset;
                `,
            },
        },
        container: {
            css: css`
                margin-bottom: 4px;
            `,
        },
    }),
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
    priceLabelText: { ...cartLineSharedStyles.headlineTypography, weight: 400, transform: "capitalize" },
};

quickOrderProductListStyles.priceTotal = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

quickOrderProductListStyles.removeProductIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

quickOrderProductListStyles.cartLineContainer = {
    qty: {
        css: css`
            @media print {
                min-width: 40%;
                min-height: 50px;
                float: left;
            }
        `,
    },
};

quickOrderProductListStyles.quantityOrdered = {
    qtyFieldStyles: {
        wrapper: {
            css: css`
                ${FormFieldStyle} {
                    max-width: 70px;
                }
            `,
        },
    },
};

quickOrderProductListStyles.headlineTypography = {
    ...cartLineSharedStyles.headlineTypography,
};
